import { ICustomer } from "../../types/customers"

export enum CustomersActionTypes {
  FETCH_CUSTOMERS_LIST = "FETCH_CUSTOMERS_LIST",
  FETCH_CUSTOMERS_LIST_SUCCESS = "FETCH_CUSTOMERS_LIST_SUCCESS",
  FETCH_CUSTOMERS_LIST_ERROR = "FETCH_CUSTOMERS_LIST_ERROR",
}

interface FetchCustomersList {
  type: CustomersActionTypes.FETCH_CUSTOMERS_LIST
}

interface FetchCustomersListSuccess {
  type: CustomersActionTypes.FETCH_CUSTOMERS_LIST_SUCCESS
  payload: ICustomer[]
}

interface FetchCustomersListError {
  type: CustomersActionTypes.FETCH_CUSTOMERS_LIST_ERROR
  payload: string
}

export type CustomersAction =
  | FetchCustomersList
  | FetchCustomersListSuccess
  | FetchCustomersListError

export interface CustomersState {
  customers: ICustomer[]
  loading: boolean
  error: string | null
}
